import Button from 'apollo-react/components/Button';
import Grid from 'apollo-react/components/Grid';
import Search from 'apollo-react-icons/Search';
import React from 'react';

import { getUITA } from '../../utils/commonUtils';
import withTranslation from '../withTranslation';

const Actions = ({ onAddCriterion, onSearch, translateString }) => (
  <Grid container spacing={1}>
    {onAddCriterion && (
      <Grid item ui-ta={getUITA('AdvancedSearch AddRow')}>
        <Button
          variant="secondary"
          onClick={onAddCriterion}
          ui-ta={getUITA('AdvancedSearch AddButton')}
        >
          {translateString('Add New Row')}
        </Button>
      </Grid>
    )}
    <Grid item>
      <Button color="primary" variant="primary" icon={Search} onClick={onSearch}>
        {translateString('Search')}
      </Button>
    </Grid>
  </Grid>
);

export default withTranslation(Actions);
